export interface FirebaseConfig {
    apiKey: string;
    authDomain: string;
    databaseURL: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
}

export interface Config {
    firebase: FirebaseConfig;
}

const configKeyMap: {[key: string]: {[key: string]: string}} = {
    firebase: {
        apiKey: "FIREBASE_API_KEY",
        authDomain: "FIREBASE_AUTH_DOMAIN",
        databaseURL: "FIREBASE_DATABASE_URL",
        projectId: "FIREBASE_PROJECT_ID",
        storageBucket: "FIREBASE_STORAGE_BUCKET",
        messagingSenderId: "FIREBASE_MESSAGING_SENDER_ID"
    }
}

const reactAppEnvPrefixMap: {[nodeEnv: string]: string} = {
    test: "REACT_APP_TEST",
    development: "REACT_APP_DEV",
    production: "REACT_APP_PROD"
}

let config: Config|null = null;

export function getConfig(): Config {
    if (config) {
        return config;
    }
    const prefix = reactAppEnvPrefixMap[process.env.NODE_ENV];
    if (!prefix) {
        throw new Error("Failed to get environment prefix for NODE_ENV=" + process.env.NODE_ENV);
    }
    const result: any = {};
    Object.keys(configKeyMap).forEach(key1 => {
        result[key1] = {};
        Object.keys(configKeyMap[key1]).forEach(key2 => {
            const envKey = `${prefix}_${configKeyMap[key1][key2]}`;
            const envValue = process.env[envKey];
            if (envValue == null) {
                throw new Error("Failed to get environment variable " + envKey);
            }
            result[key1][key2] = envValue;
        });
    });
    config = result;
    console.log(result);
    return result;
}
